// extracted by mini-css-extract-plugin
export default {"swiper":"c-a_a","swiper__wrapper":"c-a_b","swiper__slide":"c-a_c"};